module.exports = __webpack_public_path__ + "static/media/haspj.40e11ee9.svg";